import history from '@history';
import _ from '@lodash';
import loginService from 'app/services/loginService';
import * as FuseActions from 'app/store/actions/fuse';
import firebase from 'firebase/app';
import { toast } from "react-toastify";
import axios from 'axios';

export const SET_USER_DATA = '[USER] SET DATA';
export const REMOVE_USER_DATA = '[USER] REMOVE DATA';
export const USER_LOGGED_OUT = '[USER] LOGGED OUT';
export const GET_USERDATA = '[USER] GET USERDART';

let baseUrl = process.env.REACT_APP_API_KEY;
/**
 * Set user data from Auth0 token data
 */
export function setUserDataAuth0(tokenData) {
	const user = {
		role: ['admin'],
		from: 'auth0',
		data: {
			displayName: tokenData.username,
			photoURL: tokenData.picture,
			email: tokenData.email,
			settings:
				tokenData.user_metadata && tokenData.user_metadata.settings ? tokenData.user_metadata.settings : {},
			shortcuts:
				tokenData.user_metadata && tokenData.user_metadata.shortcuts ? tokenData.user_metadata.shortcuts : []
		}
	};

	return setUserData(user);
}

export function getUserData() {
	const request = axios.get(baseUrl + 'owner/getprofile', {
		headers: {
			Authorization: "Bearer " + localStorage.getItem("access_token"),
		},
	})

	return dispatch =>
		request.then(response =>
			dispatch({
				type: GET_USERDATA,
				payload: response.data.data
			})
		)
}

/**
 * Set user data from Firebase data
 */
export function setUserDataFirebase(user, authUser) {
	if (
		user &&
		user.data &&
		user.data.settings &&
		user.data.settings.theme &&
		user.data.settings.layout &&
		user.data.settings.layout.style
	) {
		// Set user data but do not update
		return setUserData(user);
	}

	// Create missing user settings
	return createUserSettingsFirebase(authUser);
}

/**
 * Create User Settings with Firebase data
 */
export function createUserSettingsFirebase(authUser) {
	return (dispatch, getState) => {
		const guestUser = getState().auth.user;
		const fuseDefaultSettings = getState().fuse.settings.defaults;
		const { currentUser } = firebase.auth();

		/**
		 * Merge with current Settings
		 */
		const user = _.merge({}, guestUser, {
			uid: authUser.uid,
			from: 'firebase',
			role: ['admin'],
			data: {
				displayName: authUser.displayName,
				email: authUser.email,
				settings: { ...fuseDefaultSettings }
			}
		});
		currentUser.updateProfile(user.data);

		updateUserData(user, dispatch);
		return dispatch(setUserData(user));
	};
}

/**
 * Set User Data
 */
export function setUserData(user) {
	// let isRole = null;
	// const userData = JSON.parse(localStorage.getItem('userData'))

	// if (userData && userData !== undefined && userData !== null && userData.userType) {
	// 	isRole = userData.userType
	// }
	return dispatch => {
		/*
		You can redirect the logged-in user to a specific route depending on his role
		 */
		if (user && user.userType && user.userType === 'Owner') {
			history.location.state = {
				redirectUrl: '/dashboard' // for example 'apps/academy'
			}
		}

		/*
		Set User Settings
		 */
		// dispatch(FuseActions.setDefaultSettings(user.data.settings));

		/*
		Set User Data
		 */
		dispatch({
			type: SET_USER_DATA,
			payload: user
		});
	};
}

/**
 * Update User Settings
 */
export function updateUserSettings(settings) {
	return (dispatch, getState) => {
		const oldUser = getState().auth.user;
		const user = _.merge({}, oldUser, { data: { settings } });

		updateUserData(user, dispatch);

		return dispatch(setUserData(user));
	};
}

/**
 * Update User Shortcuts
 */
export function updateUserShortcuts(shortcuts) {
	return (dispatch, getState) => {
		const { user } = getState().auth;
		const newUser = {
			...user,
			data: {
				...user.data,
				shortcuts
			}
		};

		updateUserData(newUser, dispatch);

		return dispatch(setUserData(newUser));
	};
}

/**
 * Remove User Data
 */
export function removeUserData() {
	return {
		type: REMOVE_USER_DATA
	};
}

/**
 * Logout
 */
export function logoutUser() {
	return (dispatch, getState) => {

		history.push({
			pathname: '/login'
		});

		loginService.logout()
		dispatch(FuseActions.setInitialSettings());
		toast.success('Logout Successfully');
		window.location.reload()
		return dispatch({
			type: USER_LOGGED_OUT
		});
	};
}

/**
 * Update User Data
 */
function updateUserData(user, dispatch) {
	if (!user.role || user.role.length === 0) {
		// is guest
		return;
	}

	// switch (user.from) {
	// 	case 'firebase': {
	// 	}
	// 	default: {
	// 		jwtService
	// 			.updateUserData(user)
	// 			.then(() => {
	// 				dispatch(MessageActions.showMessage({ message: 'User data saved with api' }));
	// 			})
	// 			.catch(error => {
	// 				dispatch(MessageActions.showMessage({ message: error.message }));
	// 			});
	// 		break;
	// 	}
	// }
}
